import create from "zustand";

export interface LicenseStoreStruct {
	classroom: boolean;
	courses: boolean;

	enableClassroom: () => void;
	disableClassroom: () => void;
	enableCourses: () => void;
	disableCourses: () => void;
}

export const useLicenseStore = create<LicenseStoreStruct>((set) => ({
	classroom: false,
	courses: false,

	enableClassroom: () => set(() => ({ classroom: true })),
	disableClassroom: () => set(() => ({ classroom: false })),
	enableCourses: () => set(() => ({ courses: true })),
	disableCourses: () => set(() => ({ courses: false })),
}));
